/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogoResponseDto } from '../../models/logo-response-dto';

export interface GetLogo$Params {}

export function getLogo(
  http: HttpClient,
  rootUrl: string,
  params?: GetLogo$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<LogoResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getLogo.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LogoResponseDto>;
    })
  );
}

getLogo.PATH = '/app-configs/logo';
